module.exports = __webpack_public_path__ + "img/call_bg.2949ceb6.png";